import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();

  if (admin === null) {
    return (
      <div className="admin-loading" data-testid="admin-auth-loading">
        <Loader2 className="admin-spinner" size={32} />
        <span>Checking session...</span>
      </div>
    );
  }

  if (admin === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
